// import API from './jsonapi-constants'

export const CONSTANTS = {
  KEY: 'cta',
  TEXT: 'buttonText',
  LINK: 'buttonLink',
  LINK_URL: 'url',
  LINK_TARGET: 'target',
  LINK_TITLE: 'title',
  TYPE: 'buttonType',
  ALIGNMENT: 'buttonAlignment',
  TYPES: {
    PRIMARY: 'primary',
    SECONDARY: 'secondary',
    BLACK: 'black',
    LINK: 'link',
    DOWNLOAD: 'download',
    BACKLINK: 'backlink',
    ERROR: 'error',
  },
}

export const PATHS = {
  TEXT: [CONSTANTS.TEXT],
  LINK: [CONSTANTS.LINK, CONSTANTS.LINK_URL],
  LINK_URL: [CONSTANTS.LINK, CONSTANTS.LINK_URL],
  LINK_TARGET: [CONSTANTS.LINK, CONSTANTS.LINK_TARGET],
  LINK_TITLE: [CONSTANTS.LINK, CONSTANTS.LINK_TITLE],
  TYPE: [CONSTANTS.TYPE],
}

export default {
  ...CONSTANTS,
  PATHS,
}
